import { CEEntityBase } from './ce-entity-base'


export class CEEntity extends CEEntityBase {

}